import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate/index";
import AppCard from "../../../components/layouts/components/AppCard";
import Products from "./parts/Products";


class ProductsPage extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={this.props.manage ? Translate.manageProducts : Translate.myProducts}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={this.props.manage ? Translate.manageProducts : Translate.myProducts}
                            action={
                                <BreadCrumbs singleLevel firstText={this.props.manage ? Translate.manageProducts : Translate.myProducts}/>
                            }>
                            <Products manage={this.props.manage}/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(ProductsPage));
